import React, { useEffect, useState, useMemo } from "react";
import { get, put } from "../../services/Services";
import { FaSave, FaTimesCircle } from "react-icons/fa";
import { BsFillSendFill } from 'react-icons/bs';
import { BsFillXCircleFill } from 'react-icons/bs';
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const PerformanceEditAdmin = ({ onSuccess, onclose, eventId, performance, registrationId, schoolId }) => {
 
  const validationSchema = Yup.object().shape({
      nombre: Yup.string().required("El nombre es obligatorio"),
      categoria: Yup.string().required("La categoría es obligatoria"),
      modalidad: Yup.string().required("La modalidad es obligatoria"),
      formas: Yup.string().required("La forma es obligatoria"),
      duration: Yup.string().required("La duración es obligatoria"),
      musicTheme: Yup.string().required("El tema musical es obligatorio"),
    });

  const [formState, setFormState] = useState({
    nombre: '',
    categoria: '',
    modalidad: '',
    formas: '',
    duration: '',
    musicTheme: 'Default',
    selectedParticipants: [],
    isChoreographed: '',
    maxTime: null,
    totalPrice: 0,
    dancePerformanceOrder: '',
  });

  const [participants, setParticipants] = useState([]);
  const [selectedParticipants, setSelectedParticipants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isRegistrationDisabled, setIsRegistrationDisabled] = useState(false);
  const [idformselected, setIdformselected] = useState(null);
  const token = localStorage.getItem("accessToken");
  //const decodedToken = jwtDecode(token);
  //const schoolId = decodedToken.schools[0].id;
  const [isChoreography, setIsChoreography] = useState(false);//almacena el valor de si es o no una coreografia
  const [hasatrainer, sethastrainer] = useState(false);//si tiene preparador
  const [trainer, setTrainer] = useState(null);
  const [hasacoregrapher, sethascoreographer] = useState(false);//si tiene coreografo
  const [coreographer, setCoreographer] = useState(null);
  const [dancePerformanceOrder, setDancePerformanceOrder] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [formDetails, setFormDetails] = useState(null);
  const [idcategoryselected, setIdcategoryselected] = useState(null);
  const [maxTime, setMaxTime] = useState(null);
  const [totalPrice, setTotalPrice] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  const [trainers, setTrainers] = useState([]);

  const exceptions = ['da', 'de', 'del', 'la', 'el', 'y', 'a', 'en', 'con','&'];

const capitalizeName = (value) => {
  const words = value.split(' ');

  return words
    .map((word, index) => {
      // Si la palabra está en la lista de excepciones, no la capitalizamos
      if (exceptions.includes(word.toLowerCase()) && index > 0) {
        return word.toLowerCase();
      }
      // Capitalizamos la primera letra de cada palabra, excepto las excepciones
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
};

  // Al cargar los datos de los participantes de la performance
  useEffect(() => {
    const fetchData = async () => {
      if (!performance?.id) {
        console.error("No se encontró el ID de la performance.");
        return;
      }
  
      try {
        const eventResponse = await get(`/api/academy/events/${eventId}`);
        const performanceResponse = await get(`/api/academy/events/registration/${registrationId}/performance/${performance.id}`);
        const participantsResponse = await get(`/api/academy/schools/${schoolId}/members?page=0&size=10000&status=true&orderby=surname`);
  
        setIdformselected(performanceResponse.data.form?.id);
        setIdcategoryselected(performanceResponse.data.category?.id);
        setDancePerformanceOrder(performanceResponse.data.order || "");
        setIsChoreography(performanceResponse.data.isChoreographed);
  
        setFormState((prevState) => ({
          ...prevState,
          eventDetails: eventResponse.data,
          nombre: performanceResponse.data.name,
          categoria: performanceResponse.data.category?.id || "",
          modalidad: performanceResponse.data.modality?.id || "",
          formas: performanceResponse.data.form?.id || "",
          duration: performanceResponse.data.duration || "",
          musicTheme: performanceResponse.data.musicTheme || "Default",
          selectedParticipants: performanceResponse.data.participants || [],
          dancePerformanceOrder: performanceResponse.data.order || "",
        }));
  
        const orderedParticipants = (participantsResponse.data.content || []).sort((a, b) =>
  `${a.surname} ${a.name}`.localeCompare(`${b.surname} ${b.name}`)
);
setParticipants(orderedParticipants);

        setSelectedParticipants(performanceResponse.data.participants.filter(
          (participant) => participant.type.id === 1
        ));
  
        const selectedTrainer = performanceResponse.data.participants.find(
          (participant) => participant.type?.id === 2
        );
        if (selectedTrainer) {
          sethastrainer(true);
          setTrainer(selectedTrainer);
        }
  
        const coreographer = performanceResponse.data.participants.find(
          (participant) => participant.type?.id === 3
        );
        if (coreographer) {
          sethascoreographer(true);
          setCoreographer(coreographer);
        }
      } catch (error) {
        console.error("Error al cargar los datos:", error);
        setError("Error al cargar los datos.");
      }
    };
  
    fetchData();
  }, [eventId, performance, schoolId]);

  useEffect(() => {
    setIsChoreography(isChoreography); // Actualiza el estado cuando isChoreographed cambie
  }, [isChoreography]);

  useEffect(() => {
      const fetchFormDetails = async () => {
        if (!idformselected) return;
  
        try {
          const response = await get(`api/academy/forms/${idformselected}`);
          setFormDetails(response.data); // Guardar detalles de la forma
        } catch (error) {
          console.error("Error al obtener detalles de la forma:", error);
        }
      };
  
      fetchFormDetails();
    }, [idformselected]);

    useEffect(() => {
        const fetchValidTime = async () => {
          if (!idcategoryselected || !idformselected) return;
    
          try {
            const response = await get(`https://ectech-software.com.ar/api/academy/valid-time?categoryId=${idcategoryselected}&formId=${idformselected}`);
            setMaxTime(response.data.duration); // Guardar la duración máxima
            setFormState((prevData) => ({
  ...prevData,
  duration: response.data.duration,
  formas: prevData.formas, // 👈 protege la forma seleccionada actual
}));// Actualizar el estado de duración
          } catch (error) {
            console.error("Error al obtener la duración válida:", error);
          }
        };
    
        fetchValidTime();
      }, [idcategoryselected, idformselected]);


    useEffect(() => {
      // Obtener el precio por participante de la forma seleccionada
      const pricePerParticipant = formState.eventDetails?.config?.forms?.find((forma) => forma.id === parseInt(formState.formas))?.price || 0;
      
      // Obtener el precio de la coreografía si está disponible
      const priceChoreography = formState.eventDetails?.config?.priceChoreography || 0;
    
      // Calcular el precio total: precio por participante + precio de coreografía si está seleccionada
      const total = selectedParticipants.length * pricePerParticipant + (isChoreography ? priceChoreography : 0);
      
      // Actualizar el estado del precio total
      setTotalPrice(total);
    }, [selectedParticipants, formState.formas, formState.eventDetails, isChoreography]);

  // Manejar selección de participantes
  const handleParticipanteChange = (e) => {
    const { value, checked } = e.target;
    const participantId = Number(value);

    if (!formDetails) {
      console.error("❌ formDetails no está disponible.");
      return;
    }

    if (checked && selectedParticipants.length >= formDetails.maximumtparticipants) {
      alert(`No puedes seleccionar más de ${formDetails.maximumtparticipants} bailarines.`);
      return;
    }

    const participant = {
      member: { id: participantId },
      type: { id: 1 }
    }
  
    // Actualizar estado de participantes seleccionados
    setSelectedParticipants(prev =>
      checked
          ? [...prev, participant].filter(
                (p, index, self) =>
                    self.findIndex(sp => sp.member.id === p.member.id) === index
            )
          : prev.filter(p => p.member.id !== participantId)
    )
  };

  // Al cargar los participantes, asignamos el id del participante con type.id === 3
  useEffect(() => {
    if (participants.length > 0) {
      const coreografo = participants.find(participant => participant.type?.id === 3);
      if (coreografo) {
        setFormState(prevState => ({
          ...prevState,
          selectedParticipantId: coreografo.id,
        }));
      }
    }
  }, [participants]);

  // Al cargar los participantes, asignamos el id del participante con type.id === 2
  useEffect(() => {
    if (participants.length > 0) {
      const preparador = participants.find(participant => participant.type?.id === 2);
      if (preparador) {
        setFormState(prevState => ({
          ...prevState,
          selectedParticipantId: preparador.id,
        }));
      }
    }
  }, [participants]);

  const handleCoreografiaChange = (e) => {
    setIsChoreography(e.target.checked);
    sethascoreographer(e.target.checked);
  };

  // Manejo de cambios en el formulario
  const handleChange = async (e) => {
    const { name, value } = e.target;
  
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  
    // Validación en tiempo real con Yup
    try {
      await validationSchema.validateAt(name, { [name]: value });
      setFormErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    } catch (err) {
      setFormErrors((prevErrors) => ({ ...prevErrors, [name]: err.message }));
    }
  
    if (name === "formas") {
      setIdformselected(value);
    }
    if (name === "dance_performance_order") {
      setDancePerformanceOrder(value);
    }
  };

   const handlehasTrainerChange = (e) => {
    sethastrainer(e.target.checked);
    if (!e.target.checked) setTrainer(null); // Resetear el select si se desmarca
   };


   // Manejar cambios en el checkbox coreografo
   const handlehascoreographer = (e) => {
    sethascoreographer(e.target.checked);
    if (!e.target.checked) setCoreographer(null); // Resetear el select si se desmarca
   };

   // Manejo del envío del formulario
   const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    if (selectedParticipants.length < formState.minParticipants) {
      setError(`Debes seleccionar al menos ${formState.minParticipants} participantes.`);
      setLoading(false);
      return;
    }

    const membersSelected = [...selectedParticipants, ...trainers, coreographer].filter(Boolean);


    const payload = {
      name: formState.nombre,
      duration: formState.duration,
      musicTheme: formState.musicTheme,
      status: true,
      isChoreographed: isChoreography,
      
      contest: { id: 2 },
      category: { id: parseInt(formState.categoria, 10) },
      modality: { id: parseInt(formState.modalidad, 10) },
      totalPrice: totalPrice,
      order: parseInt(dancePerformanceOrder, 10),
      form: { id: parseInt(formState.formas, 10) },
      participants: membersSelected,
    };

    try {
      const response = await put(`/api/academy/events/registration/${registrationId}/performance/${performance.id}`, payload);
       toast.success("Obra editada correctamente!");
      
       setTimeout(() => {
    onSuccess();
    onclose();
  }, 2000); // Espera 2 segundos antes de cerrar
    } catch (error) {
      setError("Error al editar la obra. Intente nuevamente.");
    } finally {
      setLoading(false);
    }
   };

   // Verificar si el formulario puede enviarse
   useEffect(() => {
      if (formDetails) {
        const isDisabled =
          selectedParticipants.length > formDetails.maximumtparticipants ||
          selectedParticipants.length < formDetails.minimumParticipants;
        setIsRegistrationDisabled(isDisabled);
      }
    }, [selectedParticipants, formDetails]);
    
   
   
    return (
    <div className="container mt-4">
      <h5 className="text-center mb-4 bg-primary text-white p-3 rounded">Editar Obra</h5>
      {error && <div className="alert alert-danger text-center">{error}</div>}

      <form onSubmit={handleSubmit} className="shadow-lg p-4 bg-light rounded">
        {/* Formulario de entrada */}
        <div className="form-floating mb-3">
  <input
    type="text"
    id="nombre"
    name="nombre"
    value={formState.nombre}
    onChange={(e) => {
      let value = e.target.value;

      // Aplicar la capitalización con las excepciones
      value = capitalizeName(value);

      setFormState((prev) => ({
        ...prev,
        nombre: value,
      }));

      // Validación en tiempo real
      try {
        validationSchema.validateSyncAt("nombre", { nombre: value });
        setFormErrors((prev) => ({ ...prev, nombre: "" }));
      } catch (err) {
        setFormErrors((prev) => ({ ...prev, nombre: err.message }));
      }
    }}
    className={`form-control ${formErrors.nombre ? 'is-invalid' : ''}`}
    placeholder="Nombre"
    required
  />
  <label htmlFor="nombre">Nombre:</label>
  {formErrors.nombre && <div className="invalid-feedback">{formErrors.nombre}</div>}
</div>



        {/* Selector de modalidad */}
        <div className="form-floating mb-3">
          <select
            id="modalidad"
            name="modalidad"
            value={formState.modalidad}
            onChange={handleChange}
            className="form-control"
            required
          >
            <option value="">Seleccionar Modalidad</option>
            {formState.eventDetails?.config?.modalities
              ?.slice()
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((modalidad) => (
                <option key={modalidad.id} value={modalidad.id}>
                  {modalidad.name}
                </option>
              ))}
          </select>
          <label htmlFor="modalidad">Modalidad</label>
        </div>

        {/* Selector de formas*/}
        <div className="form-floating mb-3">
          <select
            id="forma"
            name="formas"
            value={formState.formas}
            onChange={handleChange}
            className="form-control"
            required
          >
            <option value="">Seleccionar Forma</option>
            {formState.eventDetails?.config?.forms
              ?.slice()
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((forma) => (
                <option key={forma.id} value={forma.id}>
                  {forma.name}
                </option>
              ))}
          </select>
          <label htmlFor="modalidad">Forma</label>
        </div>

        {/* Mostrar detalles de la forma seleccionada */}
        {idformselected && (
          <div className="mt-1">
            <strong className="text-danger">Precio por participante: $</strong>
            <strong className="">{formState.eventDetails?.config?.forms?.find((forma) => forma.id === parseInt(idformselected))?.price || 0}</strong>
          </div>
        )}

        {/* Selector de categorias*/}
        <div className="form-floating mb-3">
          <select
            id="categoria"
            name="categoria"
            value={formState.categoria}
            onChange={handleChange}
            className="form-control"
            required
          >
            <option value="">Seleccionar Categoría</option>
            {formState.eventDetails?.config?.categories
              ?.slice()
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((categoria) => (
                <option key={categoria.id} value={categoria.id}>
                  {categoria.name}
                </option>
              ))}
          </select>
          <label htmlFor="modalidad">Categoría</label>
        </div>
        {maxTime && (
          <div className="mt-1">
            <strong className="text-danger">Duración máxima disponible: </strong><strong>{maxTime}</strong><strong> minutos.</strong>
          </div>
        )}

        {/* Tabla de participantes */}
        <div className="form-group mb-3 mt-3">
          <label>Bailarines</label>

          {/* Mostrar cantidad de participantes seleccionados */}


          <table class="table table-striped table-hover">
            <thead className="table-primary">
              <tr>
                <th className="text-center">Seleccionar</th>
                <th className="text-center">Apellido y Nombre</th>
                {/*<th className="text-center">Rol</th>*/}
              </tr>
            </thead>
            <tbody>
              {participants.map((participant) => (
                <tr key={participant.id}>
                  <td className="d-flex justify-content-center align-items-center">
                    <input
                      type="checkbox"
                      id={`participante-${participant.id}`}
                      value={participant.id}
                      onChange={handleParticipanteChange}
                      className="form-check-input"
                      checked={selectedParticipants.some(p => p.member.id === participant.id)}
                    />
                  </td>
                  <td className="text-left align-baseline">{participant.surname} {participant.name}</td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>


        <div>
          <div className="form-group mb-3">
            <label className="text-center">
              <input type="checkbox" checked={hasatrainer} onChange={handlehasTrainerChange} />
              Tiene preparador /a?
            </label>
          </div>

          {hasatrainer && (
  <div className="form-group mb-3">
    <label htmlFor="trainers">Selecciona uno o más preparadores:</label>
    <select
      id="trainers"
      className="form-control"
      multiple
      value={trainers.map((t) => t.member.id)}
      onChange={(e) => {
        const selectedOptions = Array.from(e.target.selectedOptions).map(option => ({
          member: { id: Number(option.value) },
          type: { id: 2 }
        }));
        setTrainers(selectedOptions);
      }}
    >
      {participants.map((participante) => (
        <option key={participante.id} value={participante.id}>
          {participante.name} {participante.surname}
        </option>
      ))}
    </select>
    <small className="form-text text-muted">
      Mantené presionada <strong>Ctrl</strong> (o <strong>Cmd</strong> en Mac) para seleccionar varios.
    </small>
  </div>
)}

        </div>

        {/* Checkbox para indicar si tiene coreógrafo */}
        <div className="form-group mb-3">
          <label className="text-center">
            <input
              type="checkbox"
              checked={isChoreography}
              onChange={handleCoreografiaChange}
            />
            Concursa por coreografía?
          </label>
        </div>
                 
        <div>
                {hasacoregrapher && (
                      <div className="form-group mb-3">
                        <label htmlFor="coreographer">Selecciona un coreógrafo:</label>
                        <select
                          id="coreographer"
                          className="form-control"
                          value={coreographer?.member?.id}
                          onChange={(e) => setCoreographer({
                            member: { id: e.target.value },
                            type: { id: 3 }
                          })}
                        >
                          <option value="">Seleccione Coreógrafo</option>
                          {participants.map((participante) => (
                            <option key={participante.id} value={participante.id}>
                              {participante.name} {participante.surname}
                            </option>
                          ))}
                        </select>
          
                      </div>
                    )}
          
                  </div>
        


        {/* Selector de orden de la obra */}
        <div className="form-floating mb-3">
          <select
            id="dance_performance_order"
            name="dance_performance_order"
            value={dancePerformanceOrder}  // Vinculamos al estado 'dancePerformanceOrder'
            onChange={handleChange}
            className="form-control"
            required
          >
            <option value="">Seleccionar orden</option>
            {[...Array(100)].map((_, index) => (
              <option key={index + 1} value={index + 1}>
                {index + 1}
              </option>
            ))}
          </select>
          <label htmlFor="dance_performance_order">Orden de la obra</label>
        </div>
 
        <strong className="text-secondary">
          Costo total: $ {totalPrice}
        </strong>




        <div className="d-flex gap-2">
        <button type="submit" className="btn btn-primary w-50" disabled={loading || isRegistrationDisabled}>
         <FaSave />  {loading ? "Guardando..." : "Guardar Cambios"}
        </button>
        
        <button type="button" className="btn btn-outline-secondary w-50" onClick={onclose}>
          <BsFillXCircleFill /> Cancelar
        </button>
        </div>
      </form>
     
    </div>
  );
};

export default PerformanceEditAdmin;
